import './MeterBarTooltipItem.css';
export var valueContent = '_18hto7u0-2-0-1';